var _path, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 80,
    viewBox: "0 0 126 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.246 64.9185L56.5411 39.1082L101.246 13.2978L101.246 64.9185Z",
    stroke: "black",
    strokeWidth: 9
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_7049",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.729065,
    y: 0.304932,
    width: 78.9144,
    height: 78.9144,
    rx: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.729065,
    y: 0.304932,
    width: 78.9144,
    height: 78.9144,
    rx: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 18,
    mask: "url(#path-2-inside-1_1_7049)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookout);
export default __webpack_public_path__ + "static/media/Lookout.cbdce56f.svg";
export { ForwardRef as ReactComponent };